import { useEffect } from "react";
import { useFirmaElectronica } from "hooks/useFirmaElectronica";
import { FirmaElectronicaContext } from "./context/firmaElectronicaContext";
import { FormProvider, useForm, SubmitHandler } from "react-hook-form";
import {
  FirmaElectronicaInterface,
  Inputs,
} from "./interfaces/firmaInterfaces";
import { Backdrop, Box } from "@mui/material";
import { Loading2 } from "components/ui/loading2";

export const FirmaElectronica = ({
  children,
  idsReferencias = [],
  cveTipoDocumentoFirma,
  extraParams,
  enlaceInvitado=false,
  solicitudFirma,
  derService,
  vectorService,
  firmaArchivosExtendidosService,
  validarStutusSignService,
  terminarFirmaAnticipadaService,
  obtenerStatusFirmaTerminada,
  onChange,
}: FirmaElectronicaInterface) => {
  const {
    certFile,
    keyFile,
    showPassword,
    tipo_firmante,
    errorMessage,
    loadingFirma,
    debounceSuccessMessage,
    showCertificadosGuardados,
    statusFirma,
    successFirmado,
    statusFirmaDigestiones,
    strCertificate,
    strPrivateKey,
    password,
    stepsFirmas,
    digestiones,
    oPrivateKey,
    derResData,
    vectorResData,
    iteracionesEncontradas,
    addCerFile,
    addKeyFile,
    addTipoFirmante,
    cargarScripts,
    handleClickShowPassword,
    handleMouseDownPassword,
    initialFirmado,
    readCertificate,
    readPrivateKey,
    handleClickShowCerKeySave,
    startFinishFirmaAnticipada,
    handleAddCertSelected,
    handleAddKeySelected,
    validateKeyPairs,
    compareDateCertificate,
    startFirmado,
    startDigestionFiles,
    startGetVector,
    iniciaEncontrarIteracion,
    startGetFirmaArchivoExtendidos,
  } = useFirmaElectronica(
    idsReferencias,
    cveTipoDocumentoFirma,
    extraParams,
    enlaceInvitado,
    solicitudFirma,
    derService,
    vectorService,
    firmaArchivosExtendidosService,
    validarStutusSignService,
    terminarFirmaAnticipadaService,
    obtenerStatusFirmaTerminada,
    onChange
  );
  const methods = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    data.cer = certFile;
    data.key = keyFile;
    initialFirmado(data);
  };

  useEffect(() => {
    cargarScripts();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (strCertificate && stepsFirmas.paso1) {
      compareDateCertificate();
    }
    //eslint-disable-next-line
  }, [strCertificate, stepsFirmas.paso1]);

  useEffect(() => {
    if (
      strCertificate &&
      strPrivateKey &&
      password &&
      statusFirmaDigestiones &&
      stepsFirmas.paso2
    ) {
      validateKeyPairs(password);
    }
    // eslint-disable-next-line
  }, [
    strCertificate,
    strPrivateKey,
    password,
    statusFirmaDigestiones,
    stepsFirmas.paso2,
  ]);

  useEffect(() => {
    if (statusFirmaDigestiones && stepsFirmas.paso3) {
      startFirmado();
    }
    // eslint-disable-next-line
  }, [statusFirmaDigestiones, stepsFirmas.paso3]);

  useEffect(() => {
    if (digestiones.length && oPrivateKey && stepsFirmas.paso4) {
      startDigestionFiles();
    }
    // eslint-disable-next-line
  }, [digestiones, oPrivateKey, stepsFirmas.paso4]);

  useEffect(() => {
    if (derResData.length && stepsFirmas.paso5) {
      startGetVector();
    }
    // eslint-disable-next-line
  }, [derResData && stepsFirmas.paso5]);

  useEffect(() => {
    if (vectorResData.length && stepsFirmas.paso6) {
      iniciaEncontrarIteracion();
    }
    // eslint-disable-next-line
  }, [vectorResData, stepsFirmas.paso7]);

  useEffect(() => {
    if (iteracionesEncontradas.length && stepsFirmas.paso7) {
      startGetFirmaArchivoExtendidos();
    }
    // eslint-disable-next-line
  }, [stepsFirmas.paso7]);

  return (
    <FormProvider {...methods}>
      <Backdrop open={loadingFirma} sx={{ zIndex: "9999999999" }}>
        <Box
          sx={{
            width: "50%",
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <Loading2 showText={true} message={debounceSuccessMessage} />
        </Box>
      </Backdrop>
      <form onSubmit={methods.handleSubmit(onSubmit)} autoComplete="off">
        <FirmaElectronicaContext.Provider
          value={{
            certFile,
            keyFile,
            showPassword,
            tipo_firmante,
            errorMessage,
            loadingFirma,
            showCertificadosGuardados,
            statusFirma,
            successFirmado,
            addCerFile,
            addKeyFile,
            addTipoFirmante,
            handleClickShowPassword,
            handleMouseDownPassword,
            readCertificate,
            readPrivateKey,
            handleClickShowCerKeySave,
            startFinishFirmaAnticipada,
            handleAddCertSelected,
            handleAddKeySelected,
          }}
        >
          {children({
            statusFirma,
          })}
        </FirmaElectronicaContext.Provider>
      </form>
    </FormProvider>
  );
};
